var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { MUIButton } from 'app/components/Form/index.js';
import classes from 'app/components/ButtonMenu/ButtonMenu.module.scss';
import { ClickAwayListener, Paper, Popover } from '@mui/material';
export const ButtonMenu = (props) => {
    const { children, label, component } = props, rest = __rest(props, ["children", "label", "component"]);
    const Button = component || MUIButton;
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    return (_jsxs(_Fragment, { children: [_jsx(Button, Object.assign({ onClick: handleClick }, rest, { children: label })), _jsx(Popover, { id: "simple-popper", open: open, anchorEl: anchorEl, onClose: handleClose, anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'right',
                }, transformOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                }, children: _jsx(Paper, { className: classes.paper, children: _jsx(ClickAwayListener, { onClickAway: handleClose, children: _jsx("div", { children: typeof children === 'function' ? children(handleClose) : children }) }) }) })] }));
};
